import queryString from 'querystring';

import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";

let redux = reduxCreator.type('SUB_COMMENT').plugin(axiosPlugin);

let fetchSubCommentAction = redux.fetchActionGetOne();

let createSubCommentAction = redux.fetchActionCreate();

let updateSubCommentAction = redux.fetchActionUpdate();

let deleteSubCommentAction = redux.fetchActionDelete();

export const TYPES = redux.types;

export const fetchSubComment = (type, parentId, commentId, subCommentId, query = {}) => fetchSubCommentAction(`/${type}/${parentId}/comments/${commentId}/subcomments/${subCommentId}?${queryString.stringify(query)}`);
export const createSubComment = (type, parentId, commentId, data) => createSubCommentAction(`/${type}/${parentId}/comments/${commentId}/subcomments`, data);
export const updateSubComment = (type, parentId, commentId, subCommentId, data = {}) => updateSubCommentAction(`/${type}/${parentId}/comments/${commentId}/subcomments/${subCommentId}`, data);
export const deleteSubComment = (type, parentId, commentId, subCommentId = {}) => deleteSubCommentAction(`/${type}/${parentId}/comments/${commentId}/subcomments/${subCommentId}`);

export const subComment = redux.reducer();